import { elementClicked } from '../store/helpers/tagular-events'

const createRelatedArticleTrackingEvents = element => {
  const articleLink = element.querySelector('[data-article-card-text]')
  articleLink.addEventListener('click', function() {
    let articleText = articleLink.dataset.articleCardText
    let articleLocation =
      articleLink.dataset.articleLocation || 'You may also like'
    let articleName = articleLink.dataset.articleName || null

    const webElement = {
      location: articleLocation,
      position: 'footer',
      elementType: 'link',
      text: articleText,
      htmlId: '',
      name: articleName
    }

    const actionOutcome = 'INTERNALLINK'
    const outboundUrl = ''
    const correlationId = ''

    elementClicked(
      webElement,
      actionOutcome,
      outboundUrl,
      correlationId,
      'redventures.usertracking.v3.ElementClicked'
    )
  })
}

const bindRelatedArticleTrackingEvents = selector => {
  const elements = document.querySelectorAll(selector)

  if (elements.length > 0) {
    elements.forEach(element => {
      createRelatedArticleTrackingEvents(element)
    })
  }
}

bindRelatedArticleTrackingEvents('[data-article-card]')
